import {
  Button,
  Col,
  Icon,
  Layout,
  Row,
  Spin,
  Table,
  Tag,
  Tooltip,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import Moment from "react-moment";
import { connect } from "react-redux";
import { Constant } from "../../config";
import { GatewayColor, GatewayName } from "../../config/gateway";
import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import MyModal from "../Modal";
import SendersDefaultForm from "./default-form";
import "./style.css";
import { checkRolePermission } from "../../services/permission";
import { permissionName, permissionType } from "../../config/permission";

const { Content } = Layout;

export const SENDERS_DEFAULT_HIGHEST_FLAG_UPDATING_KEY =
  "senders-default-highest-flagUpdatingData";

class SendersDefault extends Component {
  state = {
    loading: false,

    currentPage: 1,
    dataSource: [],
    isReload: false,
    totalRows: 0,
    sendersPoolList: [],

    current_data: {
      id: 0,
      senders_pool_id: 0,
    },
    flagCreateOrUpdateForm: true, // true: created, false: updated
    visibleFormModal: false,
    canReloadSenderDefault: false,
    canEditSenderDefault: false,
  };

  columns = [
    {
      align: "center",
      dataIndex: "created_date",
      render: (created_date) => {
        if (!created_date) return "-";

        return (
          <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {created_date}
          </Moment>
        );
      },
      title: "วัน / เวลา สร้าง",
      width: "150px",
    },
    {
      align: "center",
      dataIndex: "sender",
      title: "Sender",
      width: "200px",
    },
    {
      align: "center",
      dataIndex: "updated_date",
      render: (updated_date) => {
        if (!updated_date) return "-";

        return (
          <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {updated_date}
          </Moment>
        );
      },
      title: "วัน / เวลา แก้ไข ล่าสุด",
      width: "150px",
    },
    {
      align: "center",
      dataIndex: "id",
      render: (id, record) => {
        if (typeof id === "undefined") return "-";

        if (!this.state.canEditSenderDefault) {
          return <Icon type="lock" />;
        }

        return (
          <div>
            <Tooltip placement="top" title="แก้ไข">
              <Button
                icon="edit"
                onClick={() => this.edit(record || undefined)}
                style={{ marginRight: "5px" }}
              />
            </Tooltip>
          </div>
        );
      },
      title: "ดำเนินการ",
    },
  ];
  limit = 1;

  componentWillMount() {
    this.props.fetchMenuAction("senders", "senders-default");
    this.setState({ loading: true });

    const canEditSenderDefault = checkRolePermission(
      permissionName.SENDER_DEFAULT,
      permissionType.UPDATE
    );

    const canReloadSenderDefault = checkRolePermission(
      permissionName.SENDER_DEFAULT,
      permissionType.RELOAD
    );

    this.setState({ canReloadSenderDefault, canEditSenderDefault });
  }

  async componentDidMount() {
    let isReload = this.state.isReload;
    const tmp = window.localStorage.getItem(
      SENDERS_DEFAULT_HIGHEST_FLAG_UPDATING_KEY
    );
    if (+tmp === 1) isReload = true;

    await this.getDataList();
    this.setState({
      isReload,
      loading: false,
      sendersPoolList: await this.getSendersPoolList(),
    });
  }

  changePage = async (page) => {
    this.setState({
      currentPage: page,
      loading: true,
    });

    await this.getDataList(page);

    this.setState({ loading: false });
  };

  edit = (d) => {
    if (!d) return 0;
    if (!d.id || !d.sender) return 0;

    this.setState({
      current_data: {
        id: d.id,
        senders_pool_id: d.senders_pool_id,
      },
      flagCreateOrUpdateForm: false,
      visibleFormModal: true,
    });
  };

  formHandleSubmit = () => {
    const { form } = this.formRef.props;

    form.validateFields(async (err, values) => {
      if (err) return;

      MyModal.confirm(
        "ยืนยันบันทึกข้อมูล ใช่หรือไม่ ?",
        "",
        async (isConfirm) => {
          if (!isConfirm) return;

          this.setState({ loading: true });

          const modeText = this.state.flagCreateOrUpdateForm
            ? "เพิ่ม"
            : "แก้ไข";
          const errorMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeText}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
          const token = localStorage.getItem(Constant.SessionKey);
          let url = Constant.SENDERS_API_EDIT_DEFAULT_HIGHEST.replace(
            "[id]",
            values.id
          );

          const opt = {
            data: values,
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            method: this.state.flagCreateOrUpdateForm ? "POST" : "PATCH",
            url,
          };

          try {
            await axios(opt);

            if (this.state.flagCreateOrUpdateForm) form.resetFields();

            MyModal.success(`${modeText}ข้อมูลสำเร็จ`, "", async () => {
              await this.getDataList();

              window.localStorage.setItem(
                SENDERS_DEFAULT_HIGHEST_FLAG_UPDATING_KEY,
                "1"
              );

              this.setState({
                current_data: {
                  id: 0,
                  senders_pool_id: 0,
                },
                flagCreateOrUpdateForm: true,
                isReload: true,
                loading: false,
                visibleFormModal: false,
              });
            });
          } catch (e) {
            let eMsgDetail = "";

            if (e.response && e.response.data && e.response.data.error) {
              const tmp = e.response.data.error;
              eMsgDetail = `[${tmp.code || ""}] ${tmp.name || ""}`;
            }

            MyModal.error(errorMsg, eMsgDetail, () => window.location.reload());
          }
        },
        "ยืนยัน",
        "ยกเลิก"
      );
    });
  };

  formHandleCancel = () => {
    this.setState({
      current_data: {
        id: 0,
        senders_pool_id: 0,
      },
      visibleFormModal: false,
    });
  };

  getCountryAbbrTag = (country = "") => (
    <Tag color="brown" style={{ fontWeight: "bold" }}>
      {country || "-"}
    </Tag>
  );

  getDataList = async (page = 1, search = "") => {
    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.SENDERS_API_DEFAULT_HIGHEST}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: "GET",
      params: {
        page,
        limit: this.limit,
        search,
        status: "enabled",
      },
      url,
    };

    try {
      resp = await axios(opt);

      if (!resp.data) throw new Error("Response key 'data' is undefined.");
    } catch (e) {
      console.error(e);
      return;
    }

    this.setState({
      currentPage: resp.data.page || 1,
      dataSource: resp.data.data || [],
      loading: false,
      totalRows: resp.data.total_rows || 0,
    });
  };

  getGatewayTag = (gateway = "") => (
    <Tag color={GatewayColor(gateway)}>{GatewayName(gateway)}</Tag>
  );

  getSendersPoolList = async () => {
    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.SENDERS_POOL_API}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: "GET",
      params: {
        page: 1,
        limit: 1000,
        status: "enabled",
      },
      url,
    };

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data.data;
  };

  reload = async () => {
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.SENDERS_API}/default-highest/cache`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: "DELETE",
      url,
    };

    MyModal.confirm(
      `คุณต้องการ Reload ข้อมูล ใช่หรือไม่ ?`,
      "",
      async (isConfirm) => {
        if (!isConfirm) return;

        this.setState({ loading: true });

        try {
          await axios(opt);
        } catch (e) {
          console.error(e);
          MyModal.error(
            "เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง"
          );
          this.setState({ loading: false });
          return;
        }

        MyModal.success(`Reload ข้อมูล สำเร็จ`);

        await this.getDataList();

        window.localStorage.removeItem(
          SENDERS_DEFAULT_HIGHEST_FLAG_UPDATING_KEY
        );

        this.setState({
          isReload: false,
          loading: false,
        });
      },
      "ยืนยัน",
      "ยกเลิก"
    );
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  render() {
    const propsTable = {
      bordered: true,
      className: "my-table",
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize: this.limit,
        total: this.state.totalRows,
        current: this.state.currentPage,
        onChange: this.changePage,
        size: "small",
      },
      size: "small",
      scroll: {
        x: 1200,
      },
    };
    const propsTableForMobile = Object.assign({}, propsTable);

    propsTableForMobile.className = "my-table-mobile";
    propsTableForMobile.columns = this.columnsMobile;

    return (
      <Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Content
            style={{
              background: "#fff",
              padding: 24,
              margin: "16px 0",
              minHeight: 300,
            }}
          >
            <h2>Sender Default</h2>
            <p className="header-desc">
              Default Sender สูงสุดของระบบ สามารถเลือกได้ทั้งหมด (ทุก Gateway
              ทุกประเทศ)
            </p>
            <Row className="utility-bar">
              {this.state.canReloadSenderDefault && (
                <Col span={12}>
                  <Button
                    className="reload-btn"
                    type="primary"
                    onClick={() => this.reload()}
                    disabled={!this.state.isReload}
                  >
                    <Icon type="reload" />
                    Reload
                  </Button>
                  {this.state.isReload ? (
                    <span className="note-danger">
                      * กรุณากดปุ่ม Reload เพื่ออัพเดตข้อมูลใหม่
                    </span>
                  ) : null}
                </Col>
              )}
              <Col span={12}></Col>
            </Row>
            <Table {...propsTable} />
            <Table {...propsTableForMobile} />
          </Content>
        </Spin>
        <SendersDefaultForm
          loading={this.state.loading}
          data={this.state.current_data}
          flagCreateOrUpdateForm={this.state.flagCreateOrUpdateForm}
          onCancel={this.formHandleCancel}
          onCreate={this.formHandleSubmit}
          sendersPoolList={this.state.sendersPoolList}
          visible={this.state.visibleFormModal}
          wrappedComponentRef={this.saveFormRef}
          getGatewayTag={this.getGatewayTag}
          getCountryAbbrTag={this.getCountryAbbrTag}
        />
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(null, mapDispatchToProps)(SendersDefault);



// WEBPACK FOOTER //
// ./src/containers/Senders/default.js